export default __webpack_public_path__ + "static/media/portfolio-project-screenshot.70f7bfc8.png";